import React, { useState, useEffect, useCallback } from "react";
import Card from "@mui/material/Card";
import * as XLSX from "xlsx";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import Table from "examples/Tables/Table";
import Searchbar from "containers/Searchbar";
import moment from "moment";
import NoData from "containers/DataNotAvailBox";
import { serviceRow } from "./rows.js";
import ServiceSearch from "./search";
import ServiceStat from "./stat";
import { useNavigate } from "react-router-dom";
import {
  getServiceGstAmount,
  getServiceGstRate,
  getServiceReportBalance,
  getServiceTotalAmountIncludingGst,
  parseStrictNumber,
  timestampConversion,
} from "utils/common";
import { TailSpin } from "react-loader-spinner";
import { sortData } from "utils/sort.js";

function ServiceTable({
  serviceBilling,
  services,
  isSuccess,
  isFetching,
  loader,
  user,
  downloadAndStorePdf,
  setInvoiceDataHandler,
  viewHandler,
  editHandler,
}) {
  let navigate = useNavigate(); //for navigation
  const [loading, setLoading] = useState(null);
  // options for dropdown of service filter
  const [serviceOptions, setServiceOptions] = useState([]); //filtering wrt services
  const [formdata, setFormdata] = useState({});

  useEffect(() => {
    let serviceArray = services?.map((item, index) => {
      return {
        value: item?.serviceName,
        label: item?.serviceName,
        key: index,
      };
    });
    setServiceOptions(serviceArray);
  }, [services]);

  const [rows, setRows] = useState([]); // rows for billing table

  const [searchVal, setsearchVal] = useState(""); //storing search input text
  const [serviceArray, setserviceArray] = useState([]);

  // for sorting
  const [sortConfig, setSortConfig] = useState({
    key: "",
    direction: "",
    sortKey: "",
  });

  const columns = [
    { name: "S.no", align: "left", width: "30px" },

    {
      name: "Client Name",
      align: "left",
      minWidth: "150px",
      sort: true,
      sortKey: "name",
    },
    // { name: "Customer ID", align: "left", minWidth: "95px" },

    {
      name: "Selling Date/Time",
      align: "left",
      minWidth: "90px",
      sort: true,
      sortKey: "purchasedAt",
    },
    {
      name: "Phone",
      align: "left",
      minWidth: "120px",
      sort: true,
      sortKey: "phoneNumber",
    },
    // {
    //   name: "Email",
    //   align: "left",
    //   minWidth: "120px",
    //   sort: true,
    //   sortKey: "email",
    // },
    // { name: "Commencement Date", align: "left", minWidth: "150px" },
    { name: "Package", align: "left", minWidth: "170px" },
    { name: "Balance", align: "left", minWidth: "100px" },
    // { name: "Completion Date", align: "left", minWidth: "190px" },
    // { name: "Total Amount", align: "left", minWidth: "120px" },
    // { name: "Amount Paid", align: "left", minWidth: "120px" },

    // { name: "Discount", align: "left", minWidth: "120px" },
    // { name: "Balance", align: "left", minWidth: "120px" },
    // { name: "Service Type", align: "left", minWidth: "120px" },
    { name: "Action", align: "left", minWidth: "120px" },
  ];

  useEffect(() => {
    const sortedRows = sortData(serviceArray, sortConfig);

    setRows(
      serviceRow(
        sortedRows,
        user,
        navigate,
        downloadAndStorePdf,
        setInvoiceDataHandler,
        viewHandler,
        loading,
        setLoading,
        formdata,
        setFormdata,
        editHandler
      )
    );
  }, [
    serviceArray,
    navigate,
    user,
    downloadAndStorePdf,
    setInvoiceDataHandler,
    sortConfig,
    viewHandler,
    loading,
    setLoading,
  ]);

  const handleSort = (name, sortKey) => {
    let direction = "asc";
    if (sortConfig.key === name && sortConfig.direction === "asc") {
      direction = "desc";
    }

    setSortConfig({ key: name, direction, sortKey });
  };
  const [filterQuery, setFilterQuery] = useState({
    service: null,
    fromDate: null,
    toDate: null,
  }); // for filtering

  const filterHandler = () => {
    setsearchVal("");
    let timestamp;
    let filterData = serviceBilling.filter((item) => {
      if (filterQuery.service) {
        if (filterQuery.service === "all") {
          setFilterQuery({ ...filterQuery, service: null });
        } else if (filterQuery.service !== item["serviceName"]) {
          return false;
        }
      }

      if (filterQuery.fromDate) {
        timestamp = item.purchasedAt;
        timestamp =
          timestamp?.nanoseconds / 1000000 + timestamp?.seconds * 1000;
        timestamp = moment.utc(timestamp);

        if (
          new Date(filterQuery.fromDate) >
          new Date(moment(timestamp).format("YYYY-MM-DD"))
        ) {
          return false;
        }
      }

      if (filterQuery.toDate) {
        timestamp = item.purchasedAt;
        timestamp =
          timestamp?.nanoseconds / 1000000 + timestamp?.seconds * 1000;
        timestamp = moment.utc(timestamp);

        if (
          moment
            .utc(moment(filterQuery.toDate).add(24, "hours"))
            .isBefore(timestamp)
        ) {
          return false;
        }
      }
      return item;
    });
    setserviceArray(filterData);
  };

  //for resetting filters
  const resetHandler = useCallback(() => {
    setFilterQuery({
      service: null,
      fromDate: null,
      toDate: null,
    });
    setserviceArray(serviceBilling);
  }, [serviceBilling]);

  //use for search with unique code field
  useEffect(() => {
    if (!searchVal) {
      resetHandler();
      setserviceArray(serviceBilling);
    } else {
      resetHandler();
      let filteredService = serviceBilling.filter((s) => {
        let name = s?.name;
        return name.toLowerCase().includes(searchVal.toLowerCase());
      });
      setserviceArray((e) => filteredService);
    }
  }, [searchVal, isSuccess, isFetching, serviceBilling, resetHandler]);

  const excelDownload = () => {
    let updatedData = serviceArray.map((item, index) => {
      const totalAmount = getServiceTotalAmountIncludingGst(item);
      const gstRate = getServiceGstRate(item);
      const gstAmount = getServiceGstAmount(item);
      const amountPaid = parseStrictNumber(item.amountPaid);
      const discount = parseStrictNumber(item.discount);
      const balance = getServiceReportBalance(item);

      let time1 = item?.purchasedAt?.seconds
        ? moment(timestampConversion(item?.purchasedAt))
            .local()
            .format("MMMM Do YYYY, h:mm a")
        : moment(item?.purchasedAt).local().format("MMMM Do YYYY, h:mm a");

      return [
        index + 1,
        item.name,
        item.customerId ?? "N/A",
        time1,
        item.phoneNumber,
        item.email,
        item.startDate,
        item.serviceName,
        item.completionDate,
        totalAmount,
        amountPaid,
        gstRate,
        gstAmount,
        discount,
        balance,
        item.serviceInstance,
      ];
    });
    let excelData = [
      [
        "id",
        "CLIENT NAME",
        "CUSTOMER ID",
        "SELLING DATE/TIME",
        "PHONE",
        "EMAIL",
        "COMMENCEMENT DATE",
        "PACKAGE",
        "COMPLETION DATE",
        "TOTAL AMOUNT",
        "AMOUNT PAID",
        "GST(%)",
        "GST AMOUNT",
        "DISCOUNT",
        "BALANCE",
        "SERVICE TYPE",
      ],
      ...updatedData,
    ];
    let workbook = XLSX.utils.book_new();
    let worksheet = XLSX.utils.aoa_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "MySheet");
    XLSX.writeFile(workbook, "Client_List_Services.xlsx");
  };

  return (
    <SuiBox mb={3}>
      <Card style={{ overflow: "inherit" }}>
        <SuiBox
          className="search-div"
          display="flex"
          justifyContent="space-between"
          flexWrap="wrap"
          alignItems="center"
          p={3}
          pb={0}
          flexDirection={{ xs: "column-reverse", lg: "row" }}
          gap={1}
        >
          <SuiTypography
            variant="button"
            fontWeight="regular"
            color={"dark"}
            sx={{ mb: 0.75 }}
          >
            Below are the clients, who have taken your services, you can
            generate the invoice and view clients.
          </SuiTypography>
          <SuiBox
            className="search-box-div"
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "flex-end",
            }}
          >
            <Searchbar
              placeholder={"Search Client Name"}
              searchVal={searchVal}
              searchHandler={(e) => {
                setsearchVal((_) => e);
              }}
              style_={{ marginRight: 25, marginBottom: 10 }}
              clearHandler={() => {
                setsearchVal("");
              }}
            />
          </SuiBox>
        </SuiBox>

        <ServiceSearch
          setFilterQuery={setFilterQuery}
          filterHandler={filterHandler}
          filterQuery={filterQuery}
          resetHandler={resetHandler}
          serviceOptions={serviceOptions}
          excelDownload={excelDownload}
        />

        <ServiceStat service={serviceArray} />

        <SuiBox
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          {loader ? (
            <SuiBox
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginBottom: 30,
              }}
            >
              <TailSpin color="#17c1e8" height={60} width={60} />
            </SuiBox>
          ) : rows.length ? (
            <Table
              columns={columns}
              rows={rows}
              handleSort={handleSort}
              sortConfig={sortConfig}
            />
          ) : (
            <NoData />
          )}
        </SuiBox>
      </Card>
    </SuiBox>
  );
}

export default ServiceTable;
